import { Spacer } from 'components/atoms';
import { SupermarketGoodsFromSearch } from 'components/molecules/Goods/SupermarketGoodsFromSearch';
import renderIcon from 'icon';
import React from 'react';
import { IoArrowBackOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { CatergoriesCON, HeaderCon, HeaderLink } from './style';

interface Props {
  header?: React.ReactNode;
}

export const GoodsBySearch: React.FC<Props> = ({ header }) => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  return (
    <div>
      <HeaderCon sub={true}>
        {header ? (
          header
        ) : (
          <HeaderLink
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              fontSize: '1.5rem',
              fontWeight: 600
            }}>
            <span onClick={handleBack}>{renderIcon(IoArrowBackOutline, { size: 22 })}</span>
            Search Results
          </HeaderLink>
        )}
      </HeaderCon>

      <CatergoriesCON>
        <SupermarketGoodsFromSearch />
        <Spacer height={'2.5rem'} />
      </CatergoriesCON>
      <Spacer height={'4rem'} />
    </div>
  );
};
